import React from 'react';
import {connect} from "react-redux";
import '../Modal/filterModal.css';
import InputSearchFilter from '../Shared/InputSearchFilter';
import SVG from "react-inlinesvg";
import searchIcon from '../../assets/icons/searchFilter.svg'

class DepartmentModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            activeFilter:[],
            departmentList: []
        };

    }
    componentDidMount() {
        let option = this.props.option;
        let activeFilter = this.props.activeFilter;
        let department = [];
        if(activeFilter.length > 0){
            department = activeFilter;
        }else{
            option.filter((value, index, self) =>
                    index === self.findIndex((t) => {
                        if (t.department === value.department && t.department !== null && value.department !== null) {
                            if(!department.includes(value.department)){
                                department.push(value.department)
                            }
                            return value.department
                        }
                    })
            )
        }

        this.setState({departmentList: department})


    }

    handleMultiCheckboxChange = (e) => {
        let { value } = e.target;
        let activeFilter = this.state.activeFilter;
        if (activeFilter.includes(value)) {
            const filterIndex = activeFilter.indexOf(value);
            const newFilter = [...activeFilter];
            newFilter.splice(filterIndex, 1);
            this.setState({ activeFilter: newFilter });
        } else {
            this.setState({activeFilter: [...activeFilter, value] });
        }
    }
    clear = () => {

        this.props.clearFilter();
        this.setState({ activeFilter: [] })
    }


    render(){
        return(
            <div className="search-filter-wrapper">
                <div className="search-filter-modal">
                    <div className="filter-dept-content">
                        {this.state.departmentList.map((dep, k)=> {
                            return(
                                <label htmlFor={dep} key={k} >
                                    <input type="checkbox" name={dep} value={dep} id={dep} onChange={this.handleMultiCheckboxChange}/>
                                    {dep}
                                </label>
                            )
                        })}
                    </div>
                    <div className="filter-btn-container">
                        <button className={"edit-btn"} onClick={this.clear}>clear</button>
                        <button className={`apply--btn`} onClick={() => this.props.addFilter(this.state.activeFilter)}>Apply Filters</button>
                    </div>
                </div>
            </div>
        )
    }

}

export default connect(null)(DepartmentModal);